var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('card-title',{attrs:{"title":_vm.typeAttendance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }